// Caché en memoria del último Kanban por embudo (Victor 2026-06-04 · Propuesta
// 2). Vive a NIVEL DE MÓDULO → sobrevive a montar/desmontar la vista de Leads
// mientras dure la sesión del navegador, para que volver a entrar sea instantáneo
// (se muestra lo cacheado y se refresca en segundo plano).
const cache = new Map(); // pipelineId -> { pipeline, dealsByStage }

export const getKanbanCache = id => cache.get(id);
export const setKanbanCache = (id, value) => cache.set(id, value);
